import { render, staticRenderFns } from "./FeedbackPrimeiraEtapa.vue?vue&type=template&id=6d327233"
import script from "./FeedbackPrimeiraEtapa.vue?vue&type=script&lang=js"
export * from "./FeedbackPrimeiraEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports